import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Allocation',
    entityNamePlural: 'Allocations',
    entityNameModule: 'offer',
  }), [])
}
